import './styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'

import ColorPickerInput from 'components/ColorPickerInput'

const ColorPicker = ({ label, value, onChange, isRequired, error }) => (
  <div className='smartchat-field color-picker'>
    {label && (
      <div className='smartchat-field__header'>
        {label && <label>{label}</label>}
        <span>{isRequired ? `(${I18n.t('dashboard_required')})` : `(${I18n.t('dashboard_optional')})`}</span>
      </div>
    )}
    <div className='smartchat-field__body'>
      <ColorPickerInput color={value} setColor={onChange} />
    </div>
    {error && <p className='error-message'>{error}</p>}
  </div>
)

export default ColorPicker
